import axios from 'axios';

export async function updateUserEmailReports(id, userUpdateEmailReportsObject) {
  return axios.patch(`jade/api/users/${id}`, userUpdateEmailReportsObject);
}

export async function updateUserPassword(id, userUpdatePasswordObject) {
  return axios.patch(`jade/api/users/${id}`, userUpdatePasswordObject);
}
